<template>
  <UDropdownMenu
    :items="items"
    :ui="{
      content: 'w-48',
    }"
  >
    <UButton
      :avatar="{
        src: userStore.imageUrl,
        alt: userStore.getFullname,
      }"
      :ui="{
        base: 'p-0 ring-0 relative',
        leadingAvatar: 'size-8',
      }"
      size="md"
      color="neutral"
      variant="outline"
    >
      <span
        :class="{
          'text-sm absolute bottom-0 left-1/2 -translate-x-1/2 px-[2px] py-[1px] text-[8px] rounded-full bg-neutral-100 dark:bg-neutral-800': true,
          'bg-primary-100 dark:bg-primary-800': userStore.role === 'Diamond',
          'bg-warning-100 dark:bg-warning-800': userStore.role === 'Gold',
          'bg-secondary-100 dark:bg-secondary-800': userStore.role === 'Silver',
        }"
        >{{ userStore.role }}</span
      >
    </UButton>
  </UDropdownMenu>
</template>

<script setup lang="ts">
import type { DropdownMenuItem } from "@nuxt/ui";
import { typesafeI18n } from "~/locales/i18n-vue";
import { useUserStore } from "~/store";

const userStore = useUserStore();
const { LL } = typesafeI18n();

const items = computed<DropdownMenuItem[][]>(() => [
  [
    {
      label: LL.value.my_profile(),
      icon: "i-heroicons-user-circle-20-solid",
      onSelect: () => {
        navigateTo(`/users/${userStore.username}`);
      },
    },
  ],
  [
    {
      label: LL.value.update_profile(),
      icon: "i-heroicons-pencil-square-20-solid",
      onSelect: () => {
        navigateTo("/users/me");
      },
    },
    {
      label: LL.value.change_password(),
      icon: "i-heroicons-wrench-20-solid",
      onSelect: () => {
        navigateTo("/users/me/doi-mat-khau");
      },
    },
    {
      label: LL.value.upgrade_account(),
      icon: "i-heroicons-rocket-launch-20-solid",
      onSelect: () => {
        navigateTo("/nang-cap-tai-khoan");
      },
    },
  ],
  [
    {
      label: LL.value.logout(),
      icon: "i-heroicons-arrow-left-on-rectangle-20-solid",
      onSelect: () => {
        userStore.signOut();
      },
    },
  ],
]);
</script>
